import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgVar } from './directives/ng-var.directive';
import { PopupTempalateComponent } from './popup-tempalate/popup-tempalate.component';
import { ListInputDirective } from './directives/list-input.directive';
import { RectiveButtonComponent } from './rective-button/rective-button.component';
import { NbSpinnerModule } from '@nebular/theme';
import { ExportPdfComponent } from './export-pdf/export-pdf.component';
import { ProcessingAnimComponent } from './processing-anim/processing-anim.component';
import { ArrayObjectEditorComponent } from './array-object-editor/array-object-editor.component';
import { MultiSelectDropdownComponent } from './multiselect/multiselect-dropdown.component';
import { CompactMultiselectComponent } from './multiselect/compact-multiselect.component';

import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [NgVar, PopupTempalateComponent, ListInputDirective, RectiveButtonComponent, ExportPdfComponent, ProcessingAnimComponent, ArrayObjectEditorComponent, MultiSelectDropdownComponent, CompactMultiselectComponent],
  imports: [
    CommonModule,
    NbSpinnerModule,
    FormsModule
  ],
  exports: [NgVar, PopupTempalateComponent, ListInputDirective, RectiveButtonComponent, ExportPdfComponent, ProcessingAnimComponent, MultiSelectDropdownComponent, CompactMultiselectComponent]
})
export class SharedModulesModule { }
